<div class="">
  <input
    hidden
    type="file"
    [accept]="accept"
    #fileUploader
    (change)="filesChanged($event)"
  />
  <button
    *ngIf="!type"
    mat-stroked-button
    color="primary"
    type="button"
    [ngClass]="classNames"
    [disabled]="disabled"
    (click)="fileUploader.click()"
  >
    <span class="px-1">{{submitButtonText}}</span>
  </button>
  <span
    *ngIf="type"
    [class.file-input-disabled]="disabled"
    (click)="!disabled && fileUploader.click()"
  >
    <mat-icon color="primary">attach_file</mat-icon>
  </span>
</div>